const React = require("react");
const HomeView = require("./containers/HomeView");
const HomeLayout = require("layouts/HomeLayout");

// Sync route definition
module.exports = {
    path: "/",
    component: () => (
        <HomeLayout>
            <HomeView />
        </HomeLayout>
    ),
    exact: true
};



// WEBPACK FOOTER //
// ./src/routes/home/index.js